import { Component, Inject, OnInit } from "@angular/core";
import { CulturalActivity } from "@common/ADAPT.Common.Model/organisation/cultural-activity";
import { Autobind } from "@common/lib/autobind.decorator/autobind.decorator";
import { IBreezeEntity } from "@common/lib/data/breeze-entity.interface";
import { ADAPT_DIALOG_DATA } from "@common/ux/adapt-common-dialog/adapt-common-dialog.globals";
import { BaseDialogWithDiscardConfirmationComponent } from "@common/ux/adapt-common-dialog/base-dialog-with-discard-confirmation.component/base-dialog-with-discard-confirmation.component";
import { ActivitiesService } from "@org-common/lib/activities/activities.service";
import { ICalendarCulturalActivity } from "@org-common/lib/activities/activities-metadata";
import { CulturalActivityMetadataByType } from "@org-common/lib/cultural-activity/cultural-activity-type-metadata";
import { forkJoin, switchMap } from "rxjs";
import { tap } from "rxjs/operators";

@Component({
    selector: "adapt-delete-activity-dialog",
    templateUrl: "./delete-activity-dialog.component.html",
    standalone: false,
})
export class DeleteActivityDialogComponent extends BaseDialogWithDiscardConfirmationComponent<CulturalActivity> implements OnInit {
    public readonly dialogName = "DeleteActivityDialog";

    protected readonly autoResolveData = this.activity;
    public entitiesToConfirm: IBreezeEntity[];

    public activityInfo?: ICalendarCulturalActivity;

    public constructor(
        @Inject(ADAPT_DIALOG_DATA) public activity: CulturalActivity,
        private activitiesService: ActivitiesService,
    ) {
        super();

        this.entitiesToConfirm = [activity];
        if (activity.supplementaryData) {
            this.entitiesToConfirm.push(activity.supplementaryData);
        }
    }

    public get culturalActivityTypeMetadata() {
        return CulturalActivityMetadataByType[this.activity.type];
    }

    public async ngOnInit() {
        this.activityInfo = await this.activitiesService.promiseToGetCalendarEventForActivity(this.activity);
    }

    @Autobind
    public saveAndClose() {
        return forkJoin(this.entitiesToConfirm.map((e) => this.commonDataService.remove(e))).pipe(
            switchMap(() => this.commonDataService.saveEntities(this.entitiesToConfirm)),
            tap(() => this.resolve(this.activity)),
        );
    }
}
